import { Effect } from 'effect';

import { OrderToken } from '../../service/orderToken/OrderToken';

export const getOrderToken = Effect.gen(function* () {
  const orderTokenService = yield* OrderToken;
  return yield* orderTokenService.getToken;
});
